import type { IDictionary } from "@/models";
import {
  addArrayToArrayIfNotThere,
  addToArrayIfNotThere,
  removeInArray,
} from "@/utils/array";
import { createReducer } from "@reduxjs/toolkit";
import { IPubnubActions } from "./pubnub-actions";

export interface IPubnubModel {
  unreadMessages: number;
  unreadMessagesFavorites: number;
  usersTyping: string[];
  usersOnline: string[];
  usersLastOnline: IDictionary<string>;
}

const INITIAL_STATE: IPubnubModel = {
  unreadMessages: 0,
  unreadMessagesFavorites: 0,
  usersTyping: [],
  usersOnline: [],
  usersLastOnline: {},
};

/** Reducer */
export const pubnubReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(IPubnubActions.addTypingUser, (state, action): IPubnubModel => {
      return {
        ...state,
        usersTyping: addToArrayIfNotThere(state.usersTyping, action.payload),
      };
    })
    .addCase(IPubnubActions.removeTypingUser, (state, action): IPubnubModel => {
      return {
        ...state,
        usersTyping: removeInArray(state.usersTyping, action.payload),
      };
    })
    .addCase(
      IPubnubActions.setUnreadMessages,
      (state, action): IPubnubModel => {
        return {
          ...state,
          unreadMessages: action.payload.unread_messages,
        };
      }
    )
    .addCase(
      IPubnubActions.setUnreadMessagesFavorites,
      (state, action): IPubnubModel => {
        return {
          ...state,
          unreadMessagesFavorites: action.payload.unread_messages,
        };
      }
    )
    .addCase(IPubnubActions.addOnlineUser, (state, action): IPubnubModel => {
      return {
        ...state,
        usersOnline: addToArrayIfNotThere(state.usersOnline, action.payload),
        usersLastOnline: {
          ...state.usersLastOnline,
          [action.payload]: new Date().toJSON(),
        },
      };
    })
    .addCase(IPubnubActions.addOnlineUsers, (state, action): IPubnubModel => {
      const updatedUsersLastOnline = { ...state.usersLastOnline };
      action.payload.forEach((userId: string) => {
        updatedUsersLastOnline[userId] = new Date().toJSON();
      });
      return {
        ...state,
        usersOnline: addArrayToArrayIfNotThere(
          state.usersOnline,
          action.payload
        ),
        usersLastOnline: updatedUsersLastOnline,
      };
    })
    .addCase(IPubnubActions.removeOnlineUser, (state, action): IPubnubModel => {
      return {
        ...state,
        usersOnline: removeInArray(state.usersOnline, action.payload.userId),
        usersLastOnline: {
          ...state.usersLastOnline,
          [action.payload.userId]: action.payload.lastOnline,
        },
      };
    });
});
